module.exports = __webpack_public_path__ + "media/images/views/candidate/request/info-ece4ddfb856aa62260debcb8595d5fc4.png";